// import lazyLoading from './LazyLoading'
import MainLayout from '../components/admin/MainLayout'
import UserLists from '../components/admin/UserLists'

export default {
  path: '/admin',
  component: MainLayout,
  meta: {
    login: false,
    loginType: ''
  },
  children: [
    {
      path: '',
      component: UserLists,
      meta: {
        title: 'admin user lists',
        login: false,
        loginType: 'user'
      }
    }
  ]
}
